export const getLanguage = (lang: string) => {
	if (lang === 'ar') return 'ar-AR';
	if (lang === 'en') return 'en-US';
	if (lang === 'pl') return 'pl-PL';
	if (lang === 'fr') return 'fr-FR';
};
